import AppNavigationDrawer from '@/components/common/AppNavigationDrawer.vue'

export default {
  components: {
    AppNavigationDrawer
  },

  mixins: [],

  data() {
    return {
      navigationDrawer     : false,
      navigationDrawerItems: []
    }
  },

  computed: {},

  created() {

  },

  beforeDestroy() {

  },

  methods: {}
}
